import { action, computed } from "mobx";

export default class Discovery {
  isDiscovery = true;
  store;

  get id() {
    return this._id;
  }

  @computed
  get session() {
    return this.store.session.discoveries[this._id] || {};
  }

  @computed
  get node() {
    return this.nodes
      ? this.store.movie.nodes[Object.keys(this.nodes)[0]]
      : null;
  }

  @computed
  get isUnlocked() {
    return this.session
      ? this.session.unlocked || this.session.notified
      : false;
  }

  @computed
  get isVisited() {
    return !!this.session && this.session.visited;
  }

  @computed
  get thumbnailUrl() {
    return (
      this.thumburl ||
      `${this.store.config.assetPath}discoveries/thumbnails/thumb_${
        this.rawUrl
      }.jpg`
    );
  }

  @computed
  get url() {
    if (this.rawUrl.indexOf("https") === 0) {
      switch (this.type) {
        case "video":
          return this.store.makeVideoPath("disc02");
        case "html":
          return this.makeDiscoveryPath("html", "still11");
        case "image":
          return this.makeDiscoveryPath("image", "still03a");
        case "pdf":
          return this.makeDiscoveryPath("pdf", "still10");
        default:
          return this.rawUrl;
      }
    } else {
      switch (this.type) {
        case "video":
          return this.store.makeVideoPath(this.rawUrl);
        default:
          return this.makeDiscoveryPath(this.type, this.rawUrl);
      }
    }
  }

  makeDiscoveryPath = (type, id) => {
    if (type === "image") {
      type = "images";
    } else if (type === "page") {
      type = "html";
    }

    const { assetPath } = this.store.config;
    const lang = {
      en: "eng",
      es: "spa",
    }[this.store.lang];
    const ext = {
      html: "/",
      pdf: ".pdf",
      images: ".jpg",
    }[type];

    return `${assetPath}discoveries/${type}/${id}_${lang}${ext}`;
  };

  constructor(store, { url, ...data }) {
    this.store = store;
    this.rawUrl = url;
    Object.assign(this, data);
  }

  @action
  updateStatus(status) {
    const { config, profile, session } = this.store;
    const url = `${config.routes.session}/unlock/${config.movieID}/${
      profile._id
    }`;
    const id = this._id;

    const discoverySession = session.discoveries[id];

    if (discoverySession && discoverySession[status]) {
      return Promise.resolve();
    } else {
      const data = { id, [status]: true };

      if (status === "notified") {
        data.unlocked = true;
      }

      return this.store.axios
        .post(url, {
          discoveries: [data],
        })
        .then(({ data }) => {
          if (data.err === 0) {
            discoverySession[status] = true;

            if (status === "notified") {
              discoverySession.unlocked = true;
            }
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Discovery.js